import React, { useEffect, useRef, useState } from "react";
import "./Projects.css";

function Projects() {
  const projectData = [
    {
      title: "Animated Video & Storytelling",
      description: "Some of my YouTube shorts and storytelling projects.",
      videos: [
        "https://www.youtube.com/embed/Ow5_eCGzzws",
        "https://www.youtube.com/embed/4SoWLJP9H8Y",
        "https://www.youtube.com/embed/k_IClpFRhn4",
      ]
    },
    {
      title: "Coding with HTML, CSS, PHP & JavaScript",
      description: "Developing functional websites and projects using core web technologies with a focus on clean design and interactivity.",
      link: "https://github.com/khanalsanjana"
    },
    {
      title: "Content Creation",
      description: "Creating posters, reels, branding content, and voiceover scripts for digital marketing and storytelling purposes.",
    },
  ];

  // For title/subtitle animation
  const h2Ref = useRef(null);
  const h3Ref = useRef(null);

  useEffect(() => {
    const io = new IntersectionObserver(
      entries => entries.forEach(e => e.isIntersecting && e.target.classList.add("reveal")),
      { threshold: 0.4 }
    );
    [h2Ref.current, h3Ref.current].forEach(el => el && io.observe(el));
    return () => io.disconnect();
  }, []);

  // For video toggle
  const [showVideos, setShowVideos] = useState(false);

  return (
    <section className="projects" id="projects">
      <div className="projects-container">

        {/* Animated headings */}
        <h2 ref={h2Ref} className="projects-title reveal-ready">My Work & Skills</h2>
        <h3 ref={h3Ref} className="projects-subtitle reveal-ready">Crafting Stories, Code, and Creativity ✨</h3>

        <div className="projects-grid">
          {projectData.map((project, index) => (
            <div className="project-card" key={index}>
              <div className="project-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>

                {/* Toggle videos link */}
                {project.videos && (
                  <>
                    <span
                      className="github-link"
                      style={{ cursor: "pointer",fontWeight:"bold" }}
                      onClick={() => setShowVideos(prev => !prev)}
                    >
                      {showVideos ? "Hide Videos →" : "View Videos →"}
                    </span>

                    {showVideos && (
                      <div className="video-grid">
                        {project.videos.map((video, i) => (
                          <iframe
                            key={i}
                            src={video}
                            title={`YouTube video ${i}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                        ))}
                      </div>
                    )}
                  </>
                )}

                {/* GitHub link */}
                {project.link && (
                  <a className="github-link" href={project.link} target="_blank" rel="noopener noreferrer">
                    Visit GitHub →
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
